import { authSelectors } from "ducks/auth";
import { createSelector } from "reselect";
import { isAllowed, OBJECT_TYPES, OPERATIONS } from "utils/auth_utils";

export const userCanReadUnits = createSelector(
  authSelectors.permissionsSelector,
  isAllowed(OBJECT_TYPES.Units, OPERATIONS.READ)
);
